export default function NotFound() {
  return (
    <div className="notfound flex flex-direction-col align-items-center justify-content-center">
      <div className="top">
        <h1></h1>
        <ul>
          <li>홈</li>
          <li>고객센터</li>
        </ul>
      </div>
      <div className="content">
        <p className="fontbold">죄송합니다. 요청하신 페이지를 찾을 수 없습니다.</p>
        <p className="">
          방문을 원하시는 페이지의 주소가 잘못 입력되었거나, 페이지의 주소가 변경 혹은 삭제되어 요청하신
          페이지를 찾을 수 없습니다.
          <br />
          입력하신 주소가 정확한지 다시 한번 확인해 주시기 바랍니다.
          <br />
          <br />
          관련 문의사항은 천호엔케어 고객센터에 알려주시면 친절하게 안내해 드리겠습니다.
          <br />
          <br />
          감사합니다.
        </p>
      </div>
      <div className="copy">Copyright© chunhoncare Inc. All Rights Reserved.</div>
    </div>
  );
}
